import VideoPng from "./PrivateThumbnails/VideoPng.png";

export const videosData = [
  {
    url: "https://fms-s3-dev.s3.eu-central-1.amazonaws.com/video.mp4",
    title: "סרטון מובנה",
    id: "1",
    img: VideoPng,
  },
  {
    url: "https://www.youtube.com/watch?v=OFY-_saNaqs",
    title: "סרטון מיוטיוב",
    id: "2",
  },
  {
    url: "https://www.youtube.com/watch?v=OFY-_saNaqs",
    title: "סרטון מיוטיוב",
    id: "3",
  },
];
